<template>
  <div>

    <div v-if="gameType === 'Solo' || gameType === 'Practice' || gameType === 'Tournament'" class="columns">
      <div class="column is-two-fifth">
        <div class="is-size-3 player-name">
          {{ playerName(matchPlayer) }}
          <span class="player-inline-total">{{ calculateTotal(matchPlayer.throws) }}</span>
        </div>
      </div>
      <div class="column is-three-fifths">
        <div v-for="thrw in matchPlayer.throws" :thrw="thrw" :key="thrw.thrw">
          <span v-on:click="setThrowActive(thrw.id)" v-bind:class="[thrw.isActive ? 'throw-box-active' : [thrw.isBullsEye ? 'throw-box-bullseye' : 'throw-box']]">
            <AxeThrow :thrw="thrw" />
          </span>
        </div>
      </div>
    </div>

    <div v-if="gameType == GameType.ROUNDROBIN" class="columns round-robin">
      <div class="column" style="padding: 0px;">
        <div v-for="thrw in matchPlayer.throws" :thrw="thrw" :key="thrw.thrw">
          <div v-on:click="setThrowActiveRoundRobin(thrw.id)" v-bind:class="[thrw.isActive ? 'throw-box-active-round-robin' : [thrw.isBullsEye ? 'throw-box-bullseye-round-robin' : 'throw-box-round-robin']]">
            <AxeThrow :thrw="thrw" />
          </div>
        </div>
        <div style="text-align: center;">
          <span class="is-size-2 throws-total-round-robin"> {{ calculateTotal(matchPlayer.throws) }}</span>
          <i v-if="matchPlayer.winner" class="fas fa-award winner"></i>
        </div>
        <!--
        <div class="is-size-3 player-name" style="text-align: center;">
          {{ playerName(matchPlayer) }}
          <span v-if="matchPlayer != null && matchPlayer.bye"><sup>(bye)</sup></span>
        </div>
        -->
      </div>
    </div>
  </div>

</template>

<style lang="scss" scoped>
.winner {
  padding-left: 4px;
  font-size: 2.0em;
  color: gold;
}
.round-robin {
  margin: auto;
  height: 100%;
}
.player-name, .title {
  color: green;
}
.throws-total {
  padding-left: 20px;
  color: rgb(33, 103, 136);
}
.throws-total-round-robin {
  color: rgb(33, 103, 136);
  width: 60px;
  margin: auto;
  text-align: center;
}
.player-name {
  padding-right: 20px;
}
.player-inline-total {
  font-size: 0.55em;
  color: rgb(33, 103, 136);
  padding-left: 6px;
  vertical-align: middle;
}
.throws {
  padding-top: 20px;
}
.throw-box, .throw-box-round-robin {
  background-color: black;
}

.throw-box-active-round-robin, .throw-box-active {
  background-color: #0c773c;
}
.throw-box-bullseye, .throw-box-bullseye-round-robin {
  background-color: #97312d;
}
.throw-box, .throw-box-active, .throw-box-bullseye {
  border: solid gray 1px;
  padding: 5px;
  padding-left: 10px;
  margin-right: 4px;
  width: 30px;
  height: 50px;
  display: inline;
  float: left;
}
.throw-box-round-robin, .throw-box-active-round-robin, .throw-box-bullseye-round-robin {
  border: solid gray 1px;
  padding: 5px;
  margin: auto;
  width: 30px;
  height: 50px;
  margin-bottom: 10px;
}
</style>

<script>
import AxeThrow from '@/components/AxeThrow';
import { GameType } from '@/enum/gameType.js';

export default {
  props: [
    'matchPlayer',
    'gameType'
  ],
  data () {
    return {
      GameType,
      publicPath: process.env.BASE_URL,
    }
  },
  components : {
      AxeThrow
  },
  methods:{
    setThrowActiveRoundRobin: function(id) {
      //need to unset the isactive...
      this.$parent.unsetIsActive();
      for (var i = 0; i < this.matchPlayer.throws.length; i++){
        var _throw = this.matchPlayer.throws[i];
        if (_throw.id === id) {
          _throw.isActive = true;

          //if (this.matchPlayer != null) {
          //  this.$parent.$parent.$parent.submitTickerItem(this.$parent.$parent.gameData, "Now Throwing: " + this.matchPlayer.player.name ,'now_throwing', this.matchPlayer);
          //}

        } else {
          _throw.isActive = false;
        }
      }
    },
    setThrowActive: function(id) {
      this.$parent.unsetIsActive();
      for (var i = 0; i < this.matchPlayer.throws.length; i++){
        var _throw = this.matchPlayer.throws[i];
        if (_throw.id === id) {
          _throw.isActive = true;
          //_throw.basicScore = 0;

          //if (this.matchPlayer != null) {
          //  this.$parent.$parent.$parent.submitTickerItem(this.$parent.$parent.gameData, "Now Throwing: " + this.matchPlayer.player.name ,'now_throwing', this.matchPlayer);
          //}

        } else {
          _throw.isActive = false;
        }
      }
      this.$parent.forceMatchPlayersRerender();
    },
    calculateTotal(throws) {
      return this.$parent.calculateTotalThrowsMatch(throws);
    },
    calculateAxes2Total: function(throws) {
      var total = 0;
      for (var i = 0; i < throws.length; i++) {
        total += parseInt(throws[i].basicScore)*parseInt(throws[i].basicScore);
      }
      return total;
    },
    playerName: function(matchPlayer) {
      return (matchPlayer.player.given_name || matchPlayer.player.name);
      //return (this.$auth.user.given_name ? this.$auth.user.given_name : this.$auth.user.name);
    },
    getParent(name){
      //https://stackoverflow.com/questions/36722170/vue-js-using-parent-data-in-component
      let p = this.$parent;
      while(typeof p !== 'undefined'){
        if(p.$options.name == name) {
          return p;
        }else {
          p = p.$parent;
        }
      }
      return false;
    }    
  }
}
</script>
